<template src="./Social.html"> </template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            
        }
    },
    computed: {
        ...mapState({
            user: state => state.social.user
        }),

        getUser() {
            if (this.user == null) {
                this.getUserInfo()
            }
            return this.user;
        }
    },
    methods: {
        ...mapActions({
            getUserInfo: 'getUser',
        }),
        
        logout() {
            sessionStorage.removeItem('user-jwt');
            // window.location.href = 'https://127.0.0.1:8080';
            window.location.href = 'https://cloud.agroclimate.org/tools/climate-indicators-monitoring';
        }
    },
    created() {
        let uri = window.location.href.split('?');
        if(uri.length == 2) {
            let vars = uri[1].split('&');
            let getVars = {};
            let tmp = '';
            vars.forEach(function(v) {
                tmp = v.split('=');
                if(tmp.length == 2)
                getVars[tmp[0]] = tmp[1];
            });
            if (getVars.token) {
                sessionStorage.setItem('user-jwt', getVars.token)
                this.getUserInfo();
                window.history.pushState({}, document.title, "/tools/climate-indicators-monitoring/" );
            }
        }
    },
    mounted() {
        
        
    },
}
</script>

<style lang="scss" src="./Social.scss"> </style>